export default __webpack_public_path__ + "static/bream-logo-7b1bc09feef59ad456bcd8241f7ca1e4.svg";